import { Button, makeStyles, useTheme } from '@material-ui/core';
import { chatAttachmentState, isJourneyVisibleState, openChatState } from 'pages/CustomerBooking';
import React, { useEffect, useMemo, useState } from 'react';
import { toast, ToastBar, Toaster } from 'react-hot-toast';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { useTrackEvent } from 'util/trackEvent';

const useStyles = makeStyles(theme => ({
}));
const CustomToaster = ({ onChatOpen }) => {
  const classes = useStyles()
  const setChatAttachmentState = useSetRecoilState(chatAttachmentState);

  const [isJourneyVisible, setIsJourneyVisible] = useRecoilState(isJourneyVisibleState);
  const theme = useTheme()

  const trackEvent = useTrackEvent()
  return (
    <Toaster
      position="top-center"
      reverseOrder
      containerStyle={{
        top: isJourneyVisible ? theme.spacing(10):0
      }}

    >
      {(t) => (
        <ToastBar toast={t}>
          {({ icon, message }) => {
            if (t.type === 'error') {
              t.duration = Infinity
            }
            return (
              <div style={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                <div onClick={() => {
                  toast.dismiss(t.id)
                }}>
                  {icon}
                </div>
                {message}
                {t.type === 'error' && (
                  <Button size="small" 
                  variant="contained"
                  color="primary"
                  style={{flex:'none'}}
                  onClick={() => {
                    trackEvent("Opened chat - Error Report", {})
                    toast.dismiss(t.id)
                    onChatOpen()
                    setChatAttachmentState({ error: t?.error })
                  }}>Contact Support</Button>
                )}
              </div>
            )
          }}
        </ToastBar>
      )}
    </Toaster>
  )
}

export { CustomToaster }